var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"interval-column",style:(_vm.columnStyle)},_vm._l((_vm.dayDTO.time_block_list),function(terminEntryDTO){return _c('calendar-entry',{key:terminEntryDTO.id,style:(_vm.timeBlockStyles[terminEntryDTO.id]),attrs:{"termin-entry-d-t-o":terminEntryDTO,"day-conflicts":_vm.dayDTO.conflicts}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }